module.exports = __webpack_public_path__ + "media/images/favicon-c735ac184874618b13276a8be767dbfe.ico";